import { render } from "./InspectorTabs.vue?vue&type=template&id=3a446c91"
import script from "./InspectorTabs.vue?vue&type=script&lang=js"
export * from "./InspectorTabs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jjviglio/OpenMCT/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__